import { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";

const PAGE_SIZE_OPTIONS = [5, 10, 20, 50];
const DEFAULT_PAGE_SIZE = 5;

export default function AttributeTable({ geojson }) {
    const [paginationModel, setPaginationModel] = useState({
        pageSize: DEFAULT_PAGE_SIZE,
        page: 0,
    });
    if (!geojson || !geojson.features || geojson.features.length === 0) {
        return (
            <div style={{ padding: "16px", textAlign: "center", color: "#6b7280" }}>
                속성 데이터가 없습니다.
            </div>
        );
    }

    const columns = Object.keys(geojson.features[0].properties || {}).map((key) => ({
        field: key,
        headerName: key,
        sortable: true,
        width: 180,
        minWidth: 120,
    }));

    const rows = geojson.features.map((f, idx) => ({
        id: idx,
        ...f.properties,
    }));

    const requiredWidth = Math.max(columns.length * 180, 800);

    return (
        <div style={{ width: "100%", height: "100%", overflow: "auto" }}>
            <div style={{ width: requiredWidth, minWidth: "100%", height: "100%" }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    pagination
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={PAGE_SIZE_OPTIONS}
                    disableRowSelectionOnClick
                    density="compact"
                    getRowHeight={() => 'auto'}
                    sx={{
                        border: "none",
                        "& .MuiDataGrid-columnHeaders": {
                            backgroundColor: "#f3f4f6",
                            color: "#111",
                            fontWeight: 600,
                            fontSize: 14,
                            borderBottom: "1px solid #e0e0e0",
                        },
                        "& .MuiDataGrid-main": {
                            height: "calc(100% - 40px)",
                            minHeight: 0,
                        },
                        "& .MuiDataGrid-virtualScroller": {
                            minHeight: "100% !important",
                        },
                        "& .MuiDataGrid-virtualScrollerRenderZone": {
                            minHeight: "100% !important",
                        },
                        "& .MuiDataGrid-row": {
                            maxHeight: "none !important",
                        },
                        "& .MuiDataGrid-withBorderColor": {
                            borderColor: "#e0e0e0",
                        },
                        "& .MuiDataGrid-footerContainer": {
                            backgroundColor: "#f3f4f6",
                            borderTop: "1px solid #e0e0e0",
                        },
                    }}
                />
            </div>
        </div>
    );
}
